<!--
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2021-12-02 10:58:30
 * @LastEditors: Jerry
 * @LastEditTime: 2021-12-09 10:27:35
-->
<template>
  <div v-show="bool" v-Clickoutside="handleClose" class="coupon-wrap">
    <div style="overflow: auto; max-height: 359px;">
      <h5>可领取优惠券</h5>
      <NewiCoupon :data="couponList" :row="false" @handleDraw="handleDraw" />
      <!-- <Coupon v-for="(item, index) in couponList" :item="item" :key="index" /> -->
    </div>
  </div>
</template>
<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import NewiCoupon from '@/components/NewiCoupon'
export default {
  directives: { Clickoutside },
  components: { NewiCoupon },
  props: ['couponList'],
  data() {
    return {
      showRuleArr: [],
      bool: false
    }
  },
  methods: {
    handleClose() {
      this.bool = false
    },
    handleRuleDesc() {},
    handleDraw() {
      this.$emit('handleDraw')
    }
  }
}
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  text-align: left;
  color: #41485D;
  // font-family: PingFangSC-Regular, PingFang SC;
}

.coupon-wrap {
  position: absolute;
  top: 32px;
  z-index: 2;
  border: 1px solid #DFE1E8;
  border-radius: 2px 0 0;
  padding: 10px;
  width: 406px;
  background: #F0F3F5;
  box-sizing: border-box;

  h5 {
    margin-bottom: 8px;
    height: 14px;
    font-size: 14px;
    font-weight: 500;
    color: #111A34;
    line-height: 14px;
  }

  &::before {
    position: absolute;
    top: -5px;
    left: 15px;
    display: block;
    border-top: 1px solid #DFE1E8;
    border-left: 1px solid #DFE1E8;
    width: 10px;
    height: 10px;
    background: #F0F3F5;
    content: '';
    // background: red;
    transform: rotate(45deg);
  }
}
</style>
